export const GET_TOTAL_STATS = 'OHP/get_total_stats';
export const GET_GRAPH_STATS = 'OHP/get_graph_stats';

export const LEGENDS = [
    { name: 'NEW', color: '#5272AA', value: 0 },
    { name: 'RENEW', color: '#8EEED7', value: 0 },
];

